
webpack.register(
    'modules/course-map/course-map',
    function() {
        return import('modules/course-map/course-map');
    },
    true
);